import { defineComponent as u, resolveComponent as m, openBlock as e, createElementBlock as a, createBlock as l, withCtx as b, createVNode as w, createElementVNode as i, createCommentVNode as o, Fragment as d } from "vue";
import { V as g } from "../../../VImage-b57fd9d1.js";
import f from "../VLink/VLink.js";
import p from "../VSubtitle/VSubtitle.js";
import { _ as h } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/isExternalUrl.js";
import "../../../utils/tailwindUnitsConverter.js";
const _ = u({
  name: "VImageTeaser",
  components: {
    VImage: g,
    VLink: f,
    VSubtitle: p
  },
  emits: ["image-teaser:clicked"],
  props: {
    image: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      default: ""
    },
    linkTargetUrl: {
      type: String,
      default: ""
    },
    bottomImage: {
      type: String,
      default: ""
    },
    bottomImageAltText: {
      type: String,
      default: ""
    },
    bottomTitle: {
      type: String,
      default: ""
    },
    bottomSubtitle: {
      type: String,
      default: ""
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  }
});
const v = {
  key: 0,
  class: "hobi-image-teaser tw-h-80 tw-relative tw-rounded tw-overflow-hidden tw-flex-shrink-0"
}, y = {
  key: 0,
  class: "hobi-image-teaser__inner tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-between tw-items-center tw-pt-12 tw-pb-4 tw-px-4"
}, k = { class: "tw-text-center" }, x = { class: "hobi-image-teaser__bottom-wrapper tw-flex tw-flex-col tw-justify-end tw-items-center tw-max-w-full" }, I = { class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-max-w-full" }, S = { class: "hobi-image-teaser__bottom-titles-spacer tw-flex tw-items-center tw-text-center tw-max-w-full" }, T = { class: "hobi-image-teaser__bottom-titles-spacer tw-flex tw-items-center tw-text-center tw-max-w-full" }, V = {
  key: 0,
  class: "hobi-image-teaser__inner tw-absolute tw-inset-0 tw-flex tw-flex-col tw-justify-between tw-items-center tw-pt-12 tw-pb-4 tw-px-4"
}, j = { class: "tw-text-center" }, z = { class: "hobi-image-teaser__bottom-wrapper tw-flex tw-flex-col tw-justify-end tw-items-center tw-max-w-full" }, $ = { class: "tw-flex tw-flex-col tw-justify-center tw-items-center tw-max-w-full" }, C = { class: "hobi-image-teaser__bottom-titles-spacer tw-flex tw-items-center tw-text-center tw-max-w-full" }, A = { class: "hobi-image-teaser__bottom-titles-spacer tw-flex tw-items-center tw-text-center tw-max-w-full" };
function B(t, n, L, N, U, q) {
  const r = m("VImage"), s = m("VSubtitle"), c = m("VLink");
  return t.image ? (e(), a("div", v, [
    t.linkTargetUrl ? (e(), l(c, {
      key: 0,
      href: t.linkTargetUrl,
      onClick: n[0] || (n[0] = (E) => t.$emit("image-teaser:clicked")),
      router: t.router
    }, {
      default: b(() => [
        w(r, {
          image: t.image,
          role: "presentation",
          class: "tw-absolute tw-z-0 tw-inset-0 tw-h-full tw-w-full tw-bg-cover tw-object-cover",
          width: "100%",
          height: "100%"
        }, null, 8, ["image"]),
        t.bottomImage || t.bottomTitle || t.bottomSubtitle ? (e(), a("div", y, [
          i("div", k, [
            t.title ? (e(), l(s, {
              key: 0,
              title: t.title,
              size: "l",
              level: 3,
              color: "white"
            }, null, 8, ["title"])) : o("", !0)
          ]),
          i("div", x, [
            t.bottomImage ? (e(), l(r, {
              key: 0,
              image: t.bottomImage,
              "alt-text": t.bottomImageAltText,
              role: "presentation",
              class: "hobi-image-teaser__bottom-image tw-m-2.5 tw-object-cover",
              width: "44px",
              height: "44px"
            }, null, 8, ["image", "alt-text"])) : o("", !0),
            i("div", I, [
              i("div", S, [
                t.bottomTitle ? (e(), l(s, {
                  key: 0,
                  title: t.bottomTitle,
                  size: "xs",
                  level: 4,
                  color: "white"
                }, null, 8, ["title"])) : o("", !0)
              ]),
              i("div", T, [
                t.bottomSubtitle ? (e(), l(s, {
                  key: 0,
                  title: t.bottomSubtitle,
                  size: "xs",
                  level: 5,
                  color: "white"
                }, null, 8, ["title"])) : o("", !0)
              ])
            ])
          ])
        ])) : o("", !0)
      ]),
      _: 1
    }, 8, ["href", "router"])) : (e(), a(d, { key: 1 }, [
      w(r, {
        image: t.image,
        "render-as": "div",
        class: "tw-absolute tw-z-0 tw-inset-0 tw-h-full tw-w-full tw-bg-cover tw-object-cover",
        width: "100%",
        height: "100%"
      }, null, 8, ["image"]),
      t.bottomImage || t.bottomTitle || t.bottomSubtitle ? (e(), a("div", V, [
        i("div", j, [
          t.title ? (e(), l(s, {
            key: 0,
            title: t.title,
            size: "l",
            level: 3,
            color: "white"
          }, null, 8, ["title"])) : o("", !0)
        ]),
        i("div", z, [
          t.bottomImage ? (e(), l(r, {
            key: 0,
            image: t.bottomImage,
            "alt-text": t.bottomImageAltText,
            "render-as": "img",
            class: "hobi-image-teaser__bottom-image tw-m-2.5 tw-object-cover",
            width: "44px",
            height: "44px"
          }, null, 8, ["image", "alt-text"])) : o("", !0),
          i("div", $, [
            i("div", C, [
              t.bottomTitle ? (e(), l(s, {
                key: 0,
                title: t.bottomTitle,
                size: "xs",
                level: 4,
                color: "white"
              }, null, 8, ["title"])) : o("", !0)
            ]),
            i("div", A, [
              t.bottomSubtitle ? (e(), l(s, {
                key: 0,
                title: t.bottomSubtitle,
                size: "xs",
                level: 5,
                color: "white"
              }, null, 8, ["title"])) : o("", !0)
            ])
          ])
        ])
      ])) : o("", !0)
    ], 64))
  ])) : o("", !0);
}
const P = /* @__PURE__ */ h(_, [["render", B], ["__scopeId", "data-v-9f95ecc2"]]);
export {
  P as default
};
